import React from 'react'

const Video = (props) => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill={props ? props.color : '#000000'}
         xmlns="http://www.w3.org/2000/svg">
        <g opacity={props ? props.opacity : '0.5'}>
            <path
                d="M8.48468 3.09351H1.64114C0.738512 3.09351 0 3.83202 0 4.73464V10.2653C0 11.1679 0.738512 11.9064 1.64114 11.9064H8.48468C9.38731 11.9064 10.1258 11.1679 10.1258 10.2653V4.73464C10.1258 3.81561 9.38731 3.09351 8.48468 3.09351Z"
                />
            <path
                d="M13.7856 3.99616C13.6871 4.01257 13.5886 4.06181 13.5066 4.11104L10.9464 5.58806V9.39549L13.523 10.8725C13.9989 11.1515 14.5897 10.9874 14.8687 10.5115C14.9508 10.3638 15 10.1996 15 10.0191V4.94802C15 4.3408 14.4256 3.84846 13.7856 3.99616Z"
                />
        </g>
    </svg>
)

export default Video
